<template lang='pug'>
.relatedLink
  SectionTitle(sectionText='其他查核合作夥伴' :subtitleSection='true' subtitleText='(依筆畫順序)')
  ul.relatedLink-list
    li.relatedLink-item(v-for='info in infos' @click="goTo(info.id)")
      a.relatedLink-link
        .relatedLink-left
          .relatedLink-image(:style="'background-image: url(' + info.squareThumbnailUrl + ');'")
        .relatedLink-right
          .relatedLink-title {{ info.name }}
          v-clamp.relatedLink-subtitle(autoresize :max-lines="2") {{ info.description  }}
</template>
<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp,
    SectionTitle
  },
  props: {
    infos: Array
  },
  methods: {
    goTo(id) {
      this.$router.push({
        "path": "/partner",
        "query": {
          "id": id
        }
      })
    },
  }
}
</script>
